<template>
  <div class="label-container">
    <img v-if="status.key === EventState.SALES_PAUSED.key" src="/assets/sidebar-icons/sidebar-header/sales-paused.svg" :alt="adminText('shared.salesPausedIcon', 'sales paused')" width="24" height="24">
    <img v-else-if="status.key === EventState.SOLD_OUT.key" src="/assets/sidebar-icons/sidebar-header/sold-out.svg" :alt="adminText('shared.salesPausedIcon', 'sales paused')" width="24" height="24">
    <v-icon v-else size="24" :color="status.color">
      {{ icon }}
    </v-icon>
    <span class="label-container-name" :style="`color: ${status.color}`">{{ translatedStatusLabel }}</span>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { EventState } from '@/types'

export default {
  mixins: [AdminContext],
  name: 'event-status-label',
  props: {
    status: Object,
  },
  computed: {
    translatedStatusLabel() {
      const labels = {
        'UNPUBLISHED': this.adminText('shared.status.unpublished', 'UNPUBLISHED'),
        'SCHEDULED': this.adminText('shared.status.scheduled', 'SCHEDULED'),
        'PUBLISHED': this.adminText('shared.status.published', 'PUBLISHED'),
        'SALES PAUSED': this.adminText('shared.status.sales_paused', 'SALES PAUSED'),
        'CANCELED': this.adminText('shared.status.canceled', 'CANCELED'),
        'SOLD OUT': this.adminText('shared.status.sold_out', 'SOLD OUT'),
      }

      return labels[this.status.label] || this.status.label
    },
    EventState() {
      return EventState
    },
    icon(){
      let iconName
      switch(this.status.key) {
      case EventState.PUBLISHED.key:
        iconName = 'event_available'
        break
      case EventState.NO_MORE_TICKETS.key:
        iconName = 'event_available'
        break
      case EventState.DRAFT.key:
        iconName = 'edit'
        break
      case EventState.CANCELED.key:
        iconName = 'event_busy'
        break
      }

      return iconName
    },
  },
}
</script>

<style scoped>
.label-container {
  display: flex;
  height: 2.5rem;
  padding: 0 0.875rem 0 0.75rem;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;

  border-radius: 0.5rem;
  border: 1px solid #F5F5F5;
  background: white;
  mix-blend-mode: multiply;
}

.label-container-name {
  leading-trim: both;
  text-edge: cap;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  text-transform: uppercase;
}
</style>
